import React, { useState, useEffect, useCallback, useRef } from "react";
import "./Leaderboard.css";
import SEO from "components/Common/SEO";
import Footer from "components/Footer/Footer";
import { getPageTitle } from "lib/legacy";
import { t, Trans } from "@lingui/macro";
import axios from "axios";
import { CANTO, MAINNET } from "config/chains.ts";
import { getServerUrl } from "config/backend";

const Leaderboard = () => {
  const [leaderboardData, setLeaderboardData] = useState([]);
  // const yourWalletAddress = "0xe55949816d249f304F58A12E33DEe39D10eD7E11";

  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        const response = await axios.get('http://localhost:3000/api/leaderboard_volume');
        setLeaderboardData(response.data.leaderboard);
      } catch (error) {
        console.error('Error fetching leaderboard data:', error);
      }
    };

    fetchLeaderboardData();
    const intervalId = setInterval(fetchLeaderboardData, 10000);
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array means this effect runs once on mount
  
  const formatNumber = (number) => {
    const numericValue = Number(number);
    if (isNaN(numericValue)) return "$0.00";
  
    return new Intl.NumberFormat('en-US', {
      style: 'currency', // Specify currency formatting
      currency: 'USD', // Set to United States Dollar
      minimumFractionDigits: 2, // Ensure at least two decimal places
      maximumFractionDigits: 2, // You can adjust this for more precision
    }).format(numericValue/10e30);
  };

  return (
    <SEO title={getPageTitle("Leaderboard")}>
      <div className="Leaderboard-overview">
        <div className="fixed-header">
          <div className="Leaderboard-page-title">
            <Trans>Trading Leaderboard</Trans>
          </div>
          <div className="Leaderboard-page-description">
            <Trans>Climb the Leaderboard for a share of rewards!</Trans>
          </div>

          <div className="tables-container">
            <table className="leaderboard-table">
              <thead>
                <tr>
                  <th className="col-small">Rank</th>
                  <th className="col-large">Account</th>
                  <th className="col-large">Total Volume</th>
                </tr>
              </thead>
              <tbody>
                {leaderboardData.map((entry, index) => (
                    // <tr key={index} className={entry.account === yourWalletAddress ? "highlight" : ""}>
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{entry.account}</td>
                      <td>{formatNumber(entry.totalVolume)}</td>
                    </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </SEO>
  );
};

export default Leaderboard;
